import AttendanceButton from './AttendanceButton'

export default AttendanceButton
